import { loadCalendlyAssets } from './Calendly.loader';
import type { CalendlyPopupOptions } from './Calendly.types';

/**
 * Opens the Calendly popup.
 *
 * Lifecycle:
 *
 * 1. Load Calendly assets.
 * 2. Run beforeOpen().
 * 3. Immediately initialize Calendly.
 */
export const openCalendlyPopup = async ({
  url,
  beforeOpen,
}: CalendlyPopupOptions): Promise<void> => {
  if (typeof window === 'undefined') {
    throw new Error('Calendly popup can only be opened in the browser');
  }

  const trimmedUrl = url.trim();

  if (!trimmedUrl) {
    throw new Error('Calendly URL is missing');
  }

  await loadCalendlyAssets();

  const calendly = window.Calendly;

  if (!calendly?.initPopupWidget) {
    throw new Error('Calendly widget is not available');
  }

  beforeOpen?.();

  calendly.initPopupWidget({
    url: trimmedUrl,
  });
};
